import { Button, Flex, Layout, Row } from "antd";
import useWepapp from "../hook/useWepapp";
import { useMediaQuery } from "react-responsive";
import { Content, Header } from "antd/es/layout/layout";

const { Outlet } = require("react-router-dom")

const PolicyComponent = ({
    p1 = "",
    p2 = () => { },
    p3 = () => { },
    p4 = () => { },
    p5 = () => { },
    p6 = () => { },
    p7 = () => { },
    p8 = () => { },
    p9 = () => { },
    p10 = () => { },
    p11 = () => { },
    p12 = () => { },
    principle = () => { },
    policy1 = () => { },
    policy2 = () => { },
    policy3 = () => { },
    policy4 = () => { },
    policy5 = () => { },
    policy6 = () => { },
    policy7 = () => { },
    policy8 = () => { },
    policy9 = () => { },
    condition = () => { },
    policyFooter = () => { }
}) => {
    const { goToMenu = () => { } } = useWepapp()

    const isPortrait = useMediaQuery({ orientation: "portrait" })

    return (
        <Flex vertical style={{ backgroundColor: "#FCF9F6", display: "flex", flexDirection: "column" }}>
            <Flex vertical style={{ padding: "5vh", alignItems: "center", width: "100%", flexGrow: 1, rowGap: "4vh" }}>
                <h3>{p1}</h3>
                <Flex vertical style={{ height: isPortrait ? "60vh" : "30vw", width: "100%", rowGap: "5vh", overflow: "auto", scrollbarWidth: "none" }}>
                    <Row>
                        {p2()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p3()}
                        {principle()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p4()}
                        {policy1()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p5()}
                        {policy2()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p6()}
                        {policy3()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p7()}
                        {policy4()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p8()}
                        {policy5()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p9()}
                        {policy6()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p10()}
                        {policy7()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p11()}
                        {policy8()}
                    </Row>
                    <Row style={{ rowGap: "3vh" }}>
                        {p12()}
                        {policy9()}
                    </Row>
                    {condition()}
                </Flex>
            </Flex>
            {policyFooter()}
        </Flex>
    )
}
export default PolicyComponent;